// extracted by mini-css-extract-plugin
export default {"page":"iNI6yEU4EzNObPqSzxtF","content":"Ns1GaORujVM0x3S66Upp"};